const React = require('react');
const shallowCompare = require('react-addons-shallow-compare');
const couponHelper = require('../../helper/coupon-helper');
const Toast = require('../mui/toast');

import FormattedMessage from '@/intl/formatted-message';
import { formatMessage } from '../../intl/helper';
import globalMessages from '../../intl/messages/global';
import errorMessages from '../../intl/messages/error-message';

require('./dish-coupon.scss');

module.exports = React.createClass({
  displayName:'DishCoupon',
  propTypes:{
    // reducer
    shopInfo: React.PropTypes.object,
    showFixedCoupon: React.PropTypes.bool,
    closeDishCouponSuccess: React.PropTypes.func,
  },
  getDefaultProps() {
    return {
      shopInfo: {},
    };
  },
  getInitialState() {
    return {
      showDishCouponSuccess: true,
      showToastMessage: true,
    };
  },
  shouldComponentUpdate(nextProps, nextState) {
    return shallowCompare(this, nextProps, nextState);
  },
  setCouponValue(marketCoupon, bigCoupon) {
    // 展示领券成功
    if (bigCoupon) {
      if (marketCoupon.couponType === 1 || marketCoupon.couponType === 4) {
        return (
          <div className="price">{marketCoupon.ruleValue}</div>
        );
      } else if (marketCoupon.couponType === 2) {
        return (
          <div>{marketCoupon.ruleValue}<small><FormattedMessage {...globalMessages.discount} /></small></div>
        );
      }
    } else {
      // 领券成功
      if (marketCoupon.coupType === 1 || marketCoupon.coupType === 4) {
        return (
          <div className="price">{marketCoupon.value}</div>
        );
      } else if (marketCoupon.coupType === 2) {
        return (
          <div>{marketCoupon.value}<small><FormattedMessage {...globalMessages.discount} /></small></div>
        );
      }
    }
    return false;
  },
  getValidTime(couponStatus, startDate, endDate, checkTime) {
    let validTime = '';
    validTime = (
      <div>
        {
          startDate !== endDate ?
            (
            <div>
              <span className="validity-date">{couponHelper.formatDate(startDate)}</span>
              <span className="validity-date">{couponHelper.formatDate(endDate)}</span>
            </div>
            )
          :
            (
            <div>
              <span className="validity-date">{couponHelper.formatDate(startDate)}</span>
              <span className="validity-date"><FormattedMessage {...globalMessages.validOnTheDay} /></span>
            </div>
            )
        }
      </div>
    );
    return validTime;
  },
  closeCouponSuccess() {
    const { closeDishCouponSuccess } = this.props;
    this.setState({ showDishCouponSuccess:false });
    closeDishCouponSuccess();
  },
  formatCouponSuccessInfo(couponSuccessInfo) {
    const validTime = this.getValidTime(
      couponSuccessInfo.couponStatus,
      couponSuccessInfo.validStartDate,
      couponSuccessInfo.validEndDate,
      couponSuccessInfo.checkTime
    );
    const couponObj = couponHelper.loyaltyCouponParam(couponSuccessInfo);
    return (
      <div className="dish-coupon-success-content">
        <i className="dish-coupon-success-star star1"></i>
        <i className="dish-coupon-success-star star2"></i>
        <i className="dish-coupon-success-star star3"></i>
        <div className="dish-coupon-success-content-head">
          <FormattedMessage {...globalMessages.receiveSuccess} />
          <i className="dish-coupon-success-close" onTouchTap={this.closeCouponSuccess}></i>
        </div>
        <div className="dish-coupon-success-content-detail of">
          <div className="dish-coupon-inner">
            <div className="dish-coupon-content">
              <div className="clearfix" style={{ width: '100%' }}>
                <div className="dish-coupon-content__value">{this.setCouponValue(couponSuccessInfo, true)}</div>
                <div className="dish-coupon-content__title">{couponSuccessInfo.couponName}</div>
                <div className="dish-coupon-content__description">
                  {couponObj.fullValue ?
                    <FormattedMessage {...globalMessages.fullValueCanUse} values={{ fullValue: couponObj.fullValue, currency: sessionStorage.getItem('currency') }} />
                    :
                    <FormattedMessage {...globalMessages.useUnlimited} />
                  }
                  {couponObj.periodStart !== couponObj.periodEnd && <span>({couponObj.periodStart}~{couponObj.periodEnd})</span>}
                </div>
              </div>
            </div>
            <div className="dish-coupon-status">
              <div>
                <div className="dish-coupon-content__title"><FormattedMessage {...globalMessages.validityPeriod} /></div>
                <div className="dish-coupon-content__description">{validTime}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  },
  // 强制领券点击弹出浮层
  clearErrorMsg() {
    this.setState({ showToastMessage: false });
  },

  render() {
    const { showDishCouponSuccess, showToastMessage } = this.state;
    const { showFixedCoupon, shopInfo } = this.props;
    const errorMessage = formatMessage(errorMessages.successGetCoupon);

    return (
      <div className="dish-coupon-success-outer">
        {(showFixedCoupon && showDishCouponSuccess && showToastMessage || shopInfo.couponSuccess && showToastMessage) &&
          <div className="dish-menu-coupon__toast">
            <Toast errorMessage={errorMessage} clearErrorMsg={() => { this.clearErrorMsg(); }} timeout={3000} />
          </div>
        }
      </div>
    );
  },
});



// WEBPACK FOOTER //
// ./src/component/dish-menu/dish-coupon-success.jsx